module.exports = __webpack_public_path__ + "img/FR19069.8c0e5ffd.png";